import KycV2ApprovalList from "./KycV2ApprovalList";

const KycV2Page = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px]">
        <div className="flex flex-row justify-between items-center w-full mr-4">
          <p className="text-text-base text-[14px] font-semibold">KYC V2</p>
        </div>
      </div>
      <div className="mx-4 flex min-h-0 flex-1 flex-col overflow-hidden">
        <KycV2ApprovalList />
      </div>
    </div>
  );
};

export default KycV2Page;
